import { FunctionComponent, useContext } from 'react';
import { Typography, Checkbox } from '@mui/material';
import { AppContext } from '../../providers/AppContext';

interface LanguagesAndToolsProps {
    handleDrag: any;
    handleDrop: any;
    id: any;
}

const LanguagesAndTools: FunctionComponent<LanguagesAndToolsProps> = (props: LanguagesAndToolsProps) => {

    const { changeData, tech: techs } = useContext(AppContext)

    const onSelect = (id: number) => {
        const newTechs = techs.map(tech => {
            if (tech.id === id) {
                tech.choosed = true
            }
            return tech
        })

        changeData({
            tech: newTechs
        })
    }

    return (
        <div
            id={props.id}
            draggable={true}
            onDragStart={props.handleDrag}
            onDragOver={(e: any) => e.preventDefault()}
            onDrop={(e) => props.handleDrop(e, true)}
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                marginTop: 8
            }}
        >
            <Typography variant='h5' style={{
                marginBottom: 8,
            }}>Languages And Tools</Typography>

            <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                flexWrap: 'wrap'
            }}>

                {
                    techs.map(tech => {

                        return (
                            <div
                                key={tech.id}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    marginRight: 32,
                                    marginBottom: 24
                                }}
                            >
                                <Checkbox
                                    defaultChecked={tech.choosed || false}
                                    onChange={(e) => onSelect(tech.id)}
                                />
                                <td dangerouslySetInnerHTML={{ __html: tech.imageUrl }} />
                            </div>
                        )
                    })
                }


            </div>
        </div>

    );
}

export default LanguagesAndTools;